/**
 * 現在ページと href を比較するためのパス正規化（先頭は /、末尾の / は除く。ルートは /）
 */
export function normalizePathname(pathname) {
  if (!pathname) return '/';
  let p = pathname.replace(/\/+$/, '') || '/';
  return p === '' ? '/' : p;
}

/**
 * 同一オリジンのアンカーの href が現在の pathname に一致するか。
 * ルートは完全一致のみ。それ以外は一致または子パス（/company/foo）も current。
 */
export function isCurrentHref(href, currentPathname = window.location.pathname) {
  if (!href || href.startsWith('#')) return false;
  let url;
  try {
    url = new URL(href, window.location.origin);
  } catch {
    return false;
  }
  if (url.origin !== window.location.origin) return false;

  // /#about のようなハッシュリンクは current にしない
  if (url.hash) return false;

  const path = normalizePathname(currentPathname);
  const target = normalizePathname(url.pathname);
  if (target === '/') {
    return path === '/';
  }
  return path === target || path.startsWith(`${target}/`);
}

/**
 * セレクタに一致する a に、現在ページなら className（既定 is-current）を付与。
 * 汎用: 例 `markCurrentNavLinks('.js-breadcrumb a')` や `markCurrentNavLinks('[data-current-nav] a')`
 */
export function markCurrentNavLinks(selector = 'a.l-header-nav-list__link', className = 'is-current') {
  const path = window.location.pathname;
  document.querySelectorAll(selector).forEach((el) => {
    if (!(el instanceof HTMLAnchorElement)) return;
    const href = el.getAttribute('href');
    if (isCurrentHref(href, path)) {
      el.classList.add(className);
    }
  });
}

function init() {
  markCurrentNavLinks();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
